import { render, staticRenderFns } from "./CustomersFormEdit.vue?vue&type=template&id=47fa601a&scoped=true"
import script from "./CustomersFormEdit.vue?vue&type=script&lang=js"
export * from "./CustomersFormEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomersFormEdit.vue?vue&type=style&index=0&id=47fa601a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa601a",
  null
  
)

export default component.exports